import { ConservationBenchmarkType } from '@/api/rest/resources/conservation';

export const useGetConservationBenchmarks = (benchmarkBase = 100): Record<ConservationBenchmarkType, number> => {
  // TODO: MVP-5183 these values should be fetched from the back end
  return {
    [ConservationBenchmarkType.thriving]: 0.95 * benchmarkBase,
    [ConservationBenchmarkType.healthy]: 0.75 * benchmarkBase,
    [ConservationBenchmarkType.managing]: 0.5 * benchmarkBase,
    [ConservationBenchmarkType.fragile]: 0.25 * benchmarkBase,
    [ConservationBenchmarkType.degraded]: 0 * benchmarkBase,
  };
};
